import {createTheme} from "@mui/material/styles";
import { designTokens } from "./designTokens";

// Logged-in dashboard theme — neutral slate canvas with blue accent for CTAs/active only.
export const mdTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: designTokens.bgApp,
      paper: designTokens.bgSurface,
    },
    primary: {
      main: designTokens.primaryBrand,
      dark: designTokens.primaryHover,
      contrastText: designTokens.bgSurface,
    },
    secondary: {
      main: '#C2410C',
      contrastText: designTokens.bgSurface,
    },
    text: {
      primary: designTokens.textPrimary,
      secondary: designTokens.textMuted,
    },
    divider: designTokens.borderLight,
    error: {
      main: '#D32F2F',
      contrastText: designTokens.bgSurface,
    },
    warning: {
      main: '#ED6C02',
      contrastText: designTokens.bgSurface,
    },
    info: {
      main: designTokens.primaryBrand,
      contrastText: designTokens.bgSurface,
    },
    success: {
      main: '#2E7D32',
      contrastText: designTokens.bgSurface,
    },
  },
  typography: {
    fontFamily: '"Source Sans 3", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontFamily: '"Lexend", sans-serif' },
    h2: { fontFamily: '"Lexend", sans-serif' },
    h3: { fontFamily: '"Lexend", sans-serif' },
    h4: { fontFamily: '"Lexend", sans-serif' },
    h5: { fontFamily: '"Lexend", sans-serif', fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontFamily: '"Lexend", sans-serif', fontWeight: 700, letterSpacing: '-0.01em' },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: designTokens.bgApp,
          color: designTokens.textPrimary,
        },
      },
    },
    MuiLink: {
      defaultProps: {
        fontSize: 16
      },
      styleOverrides: {
        root: { color: designTokens.primaryBrand, fontWeight: 600 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
        notchedOutline: { borderColor: designTokens.borderLight },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          transition: 'background-color .15s ease, border-color .15s ease, color .15s ease, box-shadow .15s ease, transform .15s ease',
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none', transform: 'translateY(-1px)', backgroundColor: designTokens.primaryHover },
          '&:active': { transform: 'translateY(0)' },
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&:hover': { transform: 'none' },
            '&:active': { transform: 'none' },
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: 'background-color .15s ease, color .15s ease',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
          boxShadow: '0 2px 6px rgba(15,23,42,0.08), 0 28px 60px -12px rgba(15,23,42,0.24)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: designTokens.bgSurface,
          backgroundImage: 'none',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: designTokens.textPrimary,
          borderRadius: 6,
          fontSize: 12,
        },
        arrow: {
          color: designTokens.textPrimary,
        },
      },
    },
  },
});
